// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiYrPLO9scISy6pYzgMS{display:none !important}`, "",{"version":3,"sources":["webpack://./src/graphSystem/blockNodeData.module.scss"],"names":[],"mappings":"AAAA,sBACI,uBAAA","sourceRoot":""}]);
// Exports
export var hidden = `FiYrPLO9scISy6pYzgMS`;
export default ___CSS_LOADER_EXPORT___;
